import TitleButtonComp from "./src/main";

/* istanbul ignore next */
TitleButtonComp.install = function (Vue) {
  Vue.component(TitleButtonComp.name, TitleButtonComp);
};

export default TitleButtonComp;
